
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import Accordion from "@/components/UI/Accordion.vue";
import ElementStudioDynPropPaths from "@/components/ElementStudio/ElementStudioDynPropPaths.vue";
import { BuilderElement } from "@/types/elements";
import ElementStudioPropertyPaths from "@/components/ElementStudio/ElementStudioPropertyPaths.vue";
import ElementStudioSpacingBars from "@/components/ElementStudio/ElementStudioSpacingBars.vue";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";

@Component({
  components: {
    ElementStudioSpacingBars,
    ElementStudioPropertyPaths,
    ElementStudioDynPropPaths,
    Accordion
  }
})
export default class ElementStudioManagePropertyPaths extends Vue {
  @Prop()
  value!: BuilderElement;

  accordionState = "";

  toggleAccordion(key: string) {
    this.accordionState = this.accordionState === key ? "" : key;
  }

  @Inject("context") readonly context!: ElementStudioContext;

  get allPathsWithDesignAndContent() {
    return [
      this.context.element().controls.designSections.length ? "design" : null,
      this.context.element().controls.contentSections.length ? "content" : null,
      ...this.context.getPathsToAllControls([], [])
    ].filter(Boolean);
  }

  get allPaths() {
    return this.context.getPathsToAllControls();
  }

  updateElementValuePropPath(newValue: string[], propertyName: string) {
    this.context.updateElementValue(propertyName, newValue);
  }
}
